class FormErrors
{

    constructor()
    {
        this.errors = {}
    }

    all()
    {
        return this.errors
    }

    hasErrors()
    {
        return this.errors.length != 0
    }

    forget()
    {
        this.errors = {}
    }

    get(field)
    {
        if (this.has(field))
        {
            return this.errors[field][0]
        }
    }

    has(field)
    {
        return this.errors[field] ? true : false
    }

    first()
    {
        if (this.hasErrors())
            return this.get(Object.keys(this.errors)[0])
    }

    set(errors)
    {
        if (typeof errors === 'object')
            this.errors = errors
        else {
            this.errors = {
                form: ['Something went wrong']
            }
        }
    }

}

export default FormErrors


// WEBPACK FOOTER //
// ./src/utils/Errors.js